import { ILoadingScreen, ISceneLoaderProgressEvent, Observable } from '@babylonjs/core';

export class LoadingScreen implements ILoadingScreen {
  //optional, but needed due to interface definitions

  public loadingUIBackgroundColor: string;
  public loadingScreen: HTMLElement;
  public loadingScreenText: HTMLElement;
  constructor(
    private focusCanvas: Observable<void>,
    public loadingUIText: string
  ) {
    this.loadingScreen = window.document.getElementById('loadingScreen');
    this.loadingScreenText = window.document.getElementById('loadingText');
  }

  public displayLoadingUI() {
    this.loadingScreen.hidden = false;
    this.loadingScreenText.innerText = this.loadingUIText;
  }

  public hideLoadingUI(delay?: number) {
    if (delay) {
      setTimeout(() => {
        this.loadingScreen.hidden = true;
        this.focusCanvas.notifyObservers();
      }, delay);
    } else {
      this.loadingScreen.hidden = true;
      this.focusCanvas.notifyObservers();
    }
  }

  setTask(text: string, completed: boolean = true) {
    this.setProgress(text, {
      lengthComputable: false,
      loaded: completed ? 1 : 0,
      total: 1,
    });
  }

  setProgress(text: string, event: ISceneLoaderProgressEvent) {
    this.loadingUIText = text;
    let loadedPercent = 0;
    if (event.lengthComputable) {
      loadedPercent = Math.floor((event.loaded * 100) / event.total);
    } else {
      const dlCount = event.loaded / (1024 * 1024);
      loadedPercent = Math.floor((dlCount * 100.0) / 100.0);
    }
    if (event.lengthComputable) {
      this.loadingScreenText.innerText = this.loadingUIText + ' ' + loadedPercent + '%';
    } else {
      this.loadingScreenText.innerText = this.loadingUIText;
    }
  }
}
